var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file_id)?_c('google-file-link',{attrs:{"file_id":_vm.file_id}}):_vm._e(),_c('header-mapping-edit-control',{attrs:{"header_mapping":_vm.header_mapping}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }